import './HomePage.css';

const HomePage = () => {
  return (
    <div className="App">
      <section className="temporally-homepage">
        <img src="././assets/images/pokedex-logo.svg" alt="Pokédex logo" />
        <h1>Coming soon!</h1>
      </section>
    </div>
  );
};

export default HomePage;
